import { apiFetchV2 } from '@m/utils/http';
import { useMutation } from '@tanstack/react-query';

import type { AddedVia } from '@m/types/grpc/MemberOnboardingSource';
import type { UseMutationOptions } from '@tanstack/react-query';

interface AddVehicleParams {
  addedVia?: AddedVia;
  isTemporaryVehicle?: boolean;
  licensePlateStateId: number;
  licensePlateText: string;
  temporaryVehicleEndTime?: number;
}

interface AddVehicleResponse {
  vehicle: { id: number };
}

const addVehicle = (params: AddVehicleParams) =>
  apiFetchV2<AddVehicleResponse>('/customer/vehicle', {
    method: 'POST',
    body: {
      licensePlate: {
        state: { id: params.licensePlateStateId },
        text: params.licensePlateText,
      },
      isTemporaryVehicle: params.isTemporaryVehicle,
      temporaryVehicleEndTime: params.temporaryVehicleEndTime,
      addedVia: params.addedVia,
    },
  });

export const useAddVehicle = (
  options?: UseMutationOptions<AddVehicleResponse, Error, AddVehicleParams>,
) => useMutation({ mutationFn: addVehicle, ...options });
